// extracted by mini-css-extract-plugin
module.exports = {"faqSection":"FaqSectionComponent_faqSection__xZ5g6","gwSectionTitle":"FaqSectionComponent_gwSectionTitle__2-__U"};